/* Dynamic product title (nc-car-title): with a saved car (Min Garage) that a product certainly fits – its generation is
   tagged, or its model is tagged and has no generations in the selector – titles show the customer's car instead of the
   car in the stored title: the product page H1 (marker [data-nc-ct-h1]) and product card links ([data-nc-ct]).
   On the product page the car also goes on the cart line as properties[Bil]. No text about fit is ever shown (Claus 24/10).
   Elements get their data from snippets/nc-car-title-attrs.liquid; uncertain or no car: the stored title. */
(function () {
  var ALIAS = { 'volkswagen': 'vw', 'mercedes-benz': 'mercedes', 'škoda': 'skoda', 'citroën': 'citroen', 'alfa romeo': 'alfa' };
  /* What a title says after its car stays after the customer's car: "(Forstøddæmper)", "(højre fordæmper) (1 stk.)", "(5-dørs)", " - Til bagaksel (1 stk)". */
  var TAIL = /(\s+-\s+til\s+(for|bag)aksel.*|(\s*\([^()]*(støddæmper|dæmper|aksel|stk|højre|venstre|dørs|coupe|cabrio|roadster|avant|touring|sportwagon|kombi|variant|airmatic|wastegate)[^()]*\))+)\s*$/i;
  var gensCache = {}, makesP = null, seq = 0;
  var list = function (v) { return (v || '').split(',').filter(Boolean); };

  function gens(car) {
    var k = car.makeId + ':' + car.modelId;
    return gensCache[k] || (gensCache[k] = fetch(ncVehicle.API + '/types?makeId=' + car.makeId + '&modelId=' + car.modelId)
      .then(function (r) { return r.json(); }).catch(function () { return null; }));
  }
  function allMakes() {
    return makesP || (makesP = fetch(ncVehicle.API + '/makes').then(function (r) { return r.json(); })
      .then(function (l) { return l.map(function (m) { return m.name; }); }).catch(function () { return []; }));
  }

  /* Title before its car: up to the first make name, case-insensitive, with the short names titles use. */
  function head(title, names) {
    var t = ' ' + title.toLowerCase() + ' ', cut = -1;
    names.forEach(function (m) {
      m = String(m).toLowerCase();
      [m, ALIAS[m]].forEach(function (n) {
        var i = n ? t.indexOf(' ' + n + ' ') : -1;
        if (i > -1 && (cut < 0 || i < cut)) cut = i;
      });
    });
    return cut < 1 ? null : title.slice(0, cut).replace(/[\s,–-]+$/, '');
  }

  /* Promise of the title with the customer's car, or null (title stays). */
  function titleFor(d, car) {
    if (!car || !car.modelId || list(d.models).indexOf(String(car.modelId)) < 0) return Promise.resolve(null);
    var exact = car.typeId && list(d.types).indexOf(String(car.typeId)) > -1 ? Promise.resolve(true)
      : gens(car).then(function (g) { return !!g && !g.length; });
    return exact.then(function (ok) {
      if (!ok) return null;
      var t = d.title, m = t.match(TAIL), tail = m ? m[0] : '', label = ncVehicle.typeLabel(car.typeName || car.modelName);
      var join = function (h) { return h ? h + ' ' + label + tail : null; };
      if (d.neutral) return join(t.slice(0, t.length - tail.length).replace(/[\s,–-]+$/, ''));
      var h = head(t, (d.makes || '').split('|').filter(Boolean).concat(car.makeName || []));
      return h !== null ? join(h) : allMakes().then(function (a) { return join(head(t, a)); });
    });
  }

  function trunc(t, n) { return n > 0 && t.length > n ? t.slice(0, n - 3) + '...' : t; }   // as Liquid's truncate

  function cartProp(el, label) {
    var scope = el.closest('section') || document;
    scope.querySelectorAll('form[action$="/cart/add"]').forEach(function (f) {
      var i = f.querySelector('input[name="properties[Bil]"]');
      if (!label) { if (i) i.remove(); return; }
      if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[Bil]'; f.appendChild(i); }
      i.value = label;
    });
  }

  function run() {
    var my = ++seq, car = window.ncVehicle && ncVehicle.load();
    document.querySelectorAll('[data-nc-ct]').forEach(function (el) {
      var isH1 = el.hasAttribute('data-nc-ct-h1');
      var target = isH1 ? (el.closest('.product-info-main') || document).querySelector('.product-info-heading') : el;
      if (!target) return;
      titleFor(el.dataset, car).then(function (t) {
        if (my !== seq) return;
        if (t) { target.textContent = trunc(t, +el.dataset.ncCtTrunc); el.dataset.ncCtSet = '1'; }
        else if (el.dataset.ncCtSet) { target.textContent = trunc(el.dataset.title, +el.dataset.ncCtTrunc); delete el.dataset.ncCtSet; }
        if (isH1) cartProp(el, t && ncVehicle.typeLabel(car.typeName || car.modelName));
      });
    });
  }

  function start() {
    if (!window.ncVehicle) return;
    run();
    document.addEventListener('nc:car-saved', run);
    document.addEventListener('nc:car-cleared', run);
    window.addEventListener('storage', function (e) { if (e.key === ncVehicle.KEY) run(); });
    /* Filtering and infinite scroll swap in new cards: run again when elements with data-nc-ct are added. */
    var t;
    new MutationObserver(function (ms) {
      if (ms.some(function (m) { return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('[data-nc-ct]') || n.querySelector('[data-nc-ct]')); }); })) {
        clearTimeout(t); t = setTimeout(run, 50);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
